import { forwardRef } from 'react'
import { cn } from '../../lib/utils'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'elevated' | 'gradient'
  hover?: boolean
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = 'default', hover = true, children, ...props }, ref) => {
    const baseStyles = 'rounded-xl border p-6 transition-all duration-300'

    const variants = {
      default: 'bg-surface border-border',
      elevated: 'bg-surface-elevated border-border-subtle',
      gradient: 'bg-gradient-to-br from-surface-elevated to-surface border-border-subtle',
    }

    const hoverStyles = hover
      ? 'hover:border-accent/30 hover:-translate-y-1 hover:shadow-[0_8px_30px_-10px_rgba(139,92,246,0.2)]'
      : ''

    return (
      <div
        ref={ref}
        className={cn(baseStyles, variants[variant], hoverStyles, className)}
        {...props}
      >
        {children}
      </div>
    )
  },
)

Card.displayName = 'Card'
